export default "__VITE_ASSET__e489bf1f__"